"use client";

import { Button } from "@/03-presenters/components/ui/button";
import { LoadingOverlay } from "@mantine/core";
import { Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from "@nextui-org/react";
import QRCode from "react-qr-code";
import { useCreateTrade, useGetTradeStatus } from "./hooks";
import { useUserInfo } from "../../hooks";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { cx } from "class-variance-authority";
export default function SeaBayPayAction({
  packageId,
  className,
  content = "购 买"
}: {
  packageId: number;
  className?: string;
  content?: string;
}) {
  const {
    isOpen,
    onOpen,
    onOpenChange,
    onClose
  } = useDisclosure();
  const {
    isLogin,
    isHighLevelUser,
    userAuthInfo,
    isOwner
  } = useUserInfo();
  const currentRole = userAuthInfo?.role_list?.[0];
  const router = useRouter();
  const {
    createTradeRun,
    createTradeLoading,
    createTradeData
  } = useCreateTrade();
  function afterSuccess() {
    toast.success("支付成功！可在账户中心查看出海贝余额", {
      position: "top-center",
      richColors: true
    });
    onClose();
  }
  const {
    getTradeStatusRun,
    cancelPolling
  } = useGetTradeStatus(afterSuccess);
  return <>
      <Button className={cx("gradient-btn z-10 w-full cursor-pointer text-lg font-semibold", className)} disabled={isOpen} onClick={async () => {
      if (!isLogin) {
        router.push("/login");
        return;
      }
      if (!isHighLevelUser) {
        const content = `您当前是${currentRole?.name}会员，暂不可购买/使用出海贝`;
        toast.warning(content, {
          position: "top-center",
          richColors: true
        });
        return;
      }
      if (!isOwner) {
        const content = `您当前为子账户，暂不可购买/使用出海贝`;
        toast.warning(content, {
          position: "top-center",
          richColors: true
        });
        return;
      }
      onOpen();
      const res = await createTradeRun(packageId);
      if (res?.order_id) {
        getTradeStatusRun({
          packageId,
          orderId: res.order_id!
        });
      }
    }} data-sentry-element="Button" data-sentry-source-file="SeaBayPayAction.tsx">
        {content}
      </Button>
      <Modal isOpen={isOpen} onOpenChange={isOpen => {
      if (!isOpen) {
        cancelPolling();
      }
      onOpenChange();
    }} data-sentry-element="Modal" data-sentry-source-file="SeaBayPayAction.tsx">
        <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="SeaBayPayAction.tsx">
          <ModalHeader className="flex justify-center" data-sentry-element="ModalHeader" data-sentry-source-file="SeaBayPayAction.tsx">
            微信扫码支付
          </ModalHeader>
          <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="SeaBayPayAction.tsx">
            <div className="relative flex flex-col items-center justify-center gap-4">
              <LoadingOverlay visible={createTradeLoading} overlayProps={{
              radius: "sm",
              blur: 2
            }} loaderProps={{
              size: 20
            }} data-sentry-element="LoadingOverlay" data-sentry-source-file="SeaBayPayAction.tsx" />
              <span className="text-sm">
                请在<span className="text-[#5D56FB]">15:00</span>
                分钟内扫码支付当前订单
              </span>
              {createTradeData?.code_url && <div className="mb-4 size-[50%] bg-gray-200 p-4">
                  <QRCode size={128} style={{
                height: "auto",
                width: "100%",
                margin: "auto"
              }} value={createTradeData?.code_url} viewBox={`0 0 128 128`} />
                </div>}
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>;
}